import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  
  Paper,
  TextField,
  Button,
  Divider,
  ListItemIcon,
  Checkbox,
  ListItemAvatar,
  Avatar
} from '@mui/material';
import thumbnail from '../../assets/icons/thumbnail.png';

import { axiosClient,axiosPiWidrawClient, config } from '../../services/axiosClient';


const StoreReview = ({stores,setStores,categories,setCategories,setMessage,setOpenSnackBar}) => {
  const [filteredStores, setFilteredStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [search, setSearch] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isStoresLoaded, setIsStoresLoaded] = useState(false);
  const [isCategoriesLoaded,setIsCategoriesLoaded] = useState(false)
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    description: '',
    currency: '',
    merchantId: '',
    tag: '',
  });

  useEffect(() => {
    const fetchStores = async () => {
    try {
        const url = `${process.env.REACT_APP_SERVER_URL}/stores`;
      await axiosPiWidrawClient.get(url, {}, config).then((response) => {
        console.log('Fetched stores:', response.data);
      if (response.data.stores.length) {
        setFilteredStores(response.data.stores);
        setStores(response.data.stores);
        setSelectedStore(response.data.stores[0]);
        setForm(response.data.stores[0]);
      }
    }).catch((error) => {
      console.error('Error fetching stores:', error);
      setMessage({body:'Failed to fetch stores',severity:'error'});
      setOpenSnackBar(true);
    });
  } catch (error) {
    console.error('Error fetching stores:', error);
    setMessage({body:'Failed to fetch stores',severity:'error'});
    setOpenSnackBar(true);
  }
};

  const fetchCategories = async () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/category/group`;
    await axiosPiWidrawClient.get(url, {}, config).then((response) => {
        console.log('Fetched categories:', response.data);
      setCategories(response.data);
    }).catch((error) => {
      console.error('Error fetching categories:', error);
      // alert('Failed to fetch categories');
    });
    };

    if (!isStoresLoaded && stores.length === 0) {
      console.log('Fetching stores...');
      fetchStores();
    setIsStoresLoaded(true);
    }
    if(!isCategoriesLoaded && categories.length===0){
      console.log('Fetching categories...');
      fetchCategories();
      setIsCategoriesLoaded(true);
    }

  }, [setMessage, setOpenSnackBar, stores, setStores, isStoresLoaded, categories, setCategories, isCategoriesLoaded]);

  useEffect(() => {
    console.log('Selected categories:', selectedCategories);
    
     if (stores && stores.length > 0) {
        console.log('Filtering stores with search:', search);
        try{
             const results = stores.filter((store) => {
         if (!search) return true; // If search is empty, return all stores
         if (!store.name || !store.description) return false; // Ensure store has name and description
           return store.name.toLowerCase().includes(search.toLowerCase()) || store.description.toLowerCase().includes(search.toLowerCase());
       });
        //console.log('Filtered results:', results);
    setFilteredStores(results);
        }catch (error) {
        console.error('Error filtering stores:', error);
        setFilteredStores(stores);
      }
  }
  }, [search, selectedCategories, stores]);
  
  const handleStoreSelect = (store) => {
     setSelectedStore(store);
    const selectedCats = store.categories || [];
    setSelectedCategories(selectedCats);
  };

  const handleCategoryToggle = (categoryId) => {
    setSelectedCategories((prev) => {
      const exists = prev.some((cat) => cat._id === categoryId);
      if (exists) {
        return prev.filter((cat) => cat._id !== categoryId);
      } else {
        const newCat = categories.find((c) => c._id === categoryId);
        return newCat ? [...prev, newCat] : prev;
      }
    });
    console.log('Toggled category:', categoryId);
    console.log('Updated selected categories:', selectedCategories);
  };

  const handleSave = async () => {
     if (!selectedStore) return;

    const updatedStore = { ...selectedStore, categories: selectedCategories };
      console.log('Saving store:', updatedStore);
    try {
      await axiosClient.put(`${process.env.REACT_APP_SERVER_URL}/stores/${selectedStore._id}`, updatedStore, config);
      setStores((prev) => prev.map((store) => (store._id === selectedStore._id ? updatedStore : store)));
      setSelectedStore(updatedStore);
      setMessage({body:'Store updated',severity:'success'});
      setOpenSnackBar(true);
    } catch (error) {
      console.error('Error updating store:', error);
      setMessage({body:'Failed to update store',severity:'error'});
      setOpenSnackBar(true);
    }
  };

  return (
    <Box sx={{ padding: 2 }}>
    {
       stores && stores.length > 0 ? (
            <Grid container spacing={2} p={2}>
      {/* Store List */}
      <Grid item xs={12} md={4}>
        <Paper elevation={3} sx={{ p: 2, minHeight: '80vh', maxHeight: '100vh', overflowY: 'auto' }}>
          <Typography variant="h6">Stores ({filteredStores.length})</Typography>
          <TextField
            label="Search store"
            fullWidth
            size="small"
            margin="dense"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Divider sx={{ my: 1 }} />
          <List>
            {filteredStores.map((store) => (
              <ListItem
                button
                key={store._id}
                selected={selectedStore?._id === store._id}
                onClick={() => handleStoreSelect(store)}
              ><ListItemAvatar>
                  <Avatar src={store.image?.secure_url || thumbnail} alt={store.name} />
                </ListItemAvatar>
                <ListItemText
                  primary={store.name}
                  secondary={`${store.city}, ${store.state}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>

      {/* Store Details */}
      <Grid item xs={12} md={8}>
        {selectedStore ? (
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h6">Store Details</Typography>
            <Box display="flex" gap={2} my={2}>
              <Box>
                <img
                  src={selectedStore.image ?selectedStore.image?.secure_url  : thumbnail}
                  alt={selectedStore.name}
                  width="180"
                  style={{ borderRadius: 4 }}
                />
              </Box>
              <Box flex={1}>
                <TextField
                  label="Store Name"
                  value={selectedStore.name}
                  fullWidth
                  margin="dense"
                  size="small"
                />
                <TextField
                  label="Phone"
                  value={selectedStore.phone}
                  fullWidth
                  margin="dense"
                  size="small"
                />
                <TextField
                  label="Email"
                  value={selectedStore.email}
                  fullWidth
                  margin="dense"
                  size="small"
                />
                <TextField
                  label="City"
                  value={selectedStore.city}
                  fullWidth
                  margin="dense"
                  size="small"
                />
                <TextField
                  label="State"
                  value={selectedStore.state}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Box>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1">Categories</Typography>

            <List dense>
              {categories.map((category) => (
                <ListItem key={category._id} disablePadding>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={selectedCategories.some((cat) => cat._id === category._id)}
                      onChange={() => handleCategoryToggle(category._id)}
                        tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText primary={category.name} />
                </ListItem>
              ))}
            </List> 

            <Box mt={2}>
              <Button variant="contained" onClick={handleSave}>
                Save Changes
              </Button>
            </Box>
          </Paper>
        ) : (
          <Typography variant="body1">Select a store to view details.</Typography>
        )}
      </Grid>
    </Grid>
        ) : (
          <Typography variant="body1">No stores available.</Typography>
        )}
    </Box>
  );
};

export default StoreReview;
